module.exports = __webpack_public_path__ + "static/rg-01-e5796da716aed5565f0debb594a97c0f.jpg";